import { Platform, StyleSheet } from 'react-native';
import { forwardRef } from 'react';
import PhoneInput, { PhoneInputProps } from 'react-native-phone-number-input';
import { getLocales } from 'expo-localization';

import { Input, InputProps } from '../Input';
import { colors, spacing } from '../../theme';

const defaultCode = (getLocales()?.[0]?.regionCode as PhoneInputProps['defaultCode']) ?? 'US';

export const TelephoneInput = forwardRef<PhoneInput, InputProps>(
	({ onChangeText, label, optional, ...inputProps }, ref) => {
		return (
			<Input
				interactive={false}
				label={label}
				optional={optional}
				error={inputProps.error}
				errors={inputProps.errors}
				accessoryLeft={
					<PhoneInput
						defaultCode={defaultCode}
						containerStyle={styles.container}
						flagButtonStyle={styles.flagButton}
						textContentType="phoneNumber"
						onChangeFormattedText={onChangeText}
						textContainerStyle={styles.textContainerWeb}
						textInputStyle={styles.phoneTextInput}
						{...inputProps}
						ref={ref}
					/>
				}
			/>
		);
	},
);

const styles = StyleSheet.create({
	container: {
		backgroundColor: colors.transparent,
		...Platform.select({
			web: {
				width: '100%',
				paddingVertical: 0,
				height: 32,
			},
		}),
	},
	flagButton: {
		marginTop: spacing(),
		...Platform.select({
			web: {
				width: 64,
				marginTop: spacing(0.5),
			},
		}),
	},
	textContainerWeb: {
		...Platform.select({
			web: {
				paddingHorizontal: spacing(2),
				paddingVertical: 0,
				backgroundColor: 'transparent',
			},
		}),
	},
	phoneTextInput: {
		...Platform.select({
			web: {
				width: '100%',
				height: '100%',
			},
		}),
	},
});
